import { RiMore2Fill } from 'react-icons/ri';
import { Dropdown, DropdownToggleType, MenuItem } from '@Components/Dropdown';
import { Size, StretchMode } from '@Components/designConstants';

interface KebabMenuProps<V extends string> {
  items: MenuItem<V>[];
  onSelect: (value: V) => void;
}

// The menu is fixed-positioned, so a scrolling list or a card does not clip it.
export const KebabMenu = <V extends string>({ items, onSelect }: KebabMenuProps<V>) => (
  <Dropdown
    type={DropdownToggleType.ICON_ONLY}
    ariaLabel='More actions'
    options={items}
    onChange={onSelect}
    leadingIcon={<RiMore2Fill />}
    size={Size.SM}
    stretch={StretchMode.FIT}
    menuAlign='end'
    menuStrategy='fixed'
  />
);
